import type { ReferralStatus } from './enums';

export const SCHOOL_TIME_ZONE = 'America/New_York';
export const ALLOTMENT_FULL = 'ALLOTMENT_FULL';
export const INACTIVE_RECOMMENDATION_STATUSES: readonly ReferralStatus[] = ['archived'];

const schoolDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: SCHOOL_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function schoolToday(now: Date = new Date()): string {
  return schoolDate.format(now);
}

export function cycleEnded(endsOn: string | null | undefined, now: Date = new Date()): boolean {
  return !!endsOn && endsOn < schoolToday(now);
}

export interface AllotmentRecord {
  countsTowardAllotment: boolean;
  status: ReferralStatus;
  cycleEndsOn: string | null | undefined;
}

export function isActiveRecommendation(r: AllotmentRecord, now: Date = new Date()): boolean {
  return (
    r.countsTowardAllotment &&
    !INACTIVE_RECOMMENDATION_STATUSES.includes(r.status) &&
    !cycleEnded(r.cycleEndsOn, now)
  );
}

export function countActiveRecommendations(
  records: readonly AllotmentRecord[],
  now: Date = new Date(),
): number {
  return records.filter((r) => isActiveRecommendation(r, now)).length;
}

export function recordNoun(countsTowardAllotment: boolean): 'Recommendation' | 'Referral' {
  return countsTowardAllotment ? 'Recommendation' : 'Referral';
}

export function allotmentFullMessage(active: number): string {
  return `You already have ${active} active Trustee recommendations for this academic year. Archive or unmark one before marking another.`;
}

export type RecommendationGroup = 'draft' | 'submitted' | 'expired';

export function recommendationGroup(r: {
  status: ReferralStatus;
  cycleEnded: boolean;
}): RecommendationGroup {
  if (r.cycleEnded) return 'expired';
  return r.status === 'draft' ? 'draft' : 'submitted';
}
